"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STEPS_PMC_COVID_VACCINE = exports.STEPS_PMC_DEFAULT = void 0;
const States_1 = require("./States");
/**
 * stateKey: refers to the state of the state machine
 * stepperLabelId: messages id if the step appears in the stepper. If null, step won't appear in the stepper
 * path: relative path that will be pushed onto history when this step is in the UI
 */
exports.STEPS_PMC_DEFAULT = 'STEPS_PMC_DEFAULT';
exports.STEPS_PMC_COVID_VACCINE = 'STEPS_PMC_COVID_VACCINE';
// export const STEPS_PMAC_DEFAULT = 'STEPS_PMAC_DEFAULT'; // @TODO: ONLY HERE AS AN EXAMPLE STUB
exports.default = {
    [exports.STEPS_PMC_DEFAULT]: [
        {
            stateKey: States_1.apptInfo,
            stepperLabelId: 'stepperApptInfo',
            ariaLabelId: 'ariaApptInfo',
            path: ''
        },
        {
            stateKey: States_1.apptTime,
            stepperLabelId: 'stepperApptTime',
            ariaLabelId: 'ariaApptTime',
            path: '/appt-time'
        },
        {
            stateKey: States_1.patientInfo,
            stepperLabelId: 'stepperPatientInfo',
            ariaLabelId: 'ariaPatientInfo',
            path: '/patient-info'
        },
        {
            stateKey: States_1.apptSummary,
            stepperLabelId: 'appointmentConfirmedTitle',
            ariaLabelId: null,
            path: '/appt-summary'
        }
    ],
    [exports.STEPS_PMC_COVID_VACCINE]: [
        {
            stateKey: States_1.apptInfo,
            stepperLabelId: 'stepperApptInfo',
            ariaLabelId: 'ariaApptInfo',
            path: ''
        },
        {
            stateKey: States_1.patientInfo,
            stepperLabelId: 'stepperPatientInfo',
            ariaLabelId: 'ariaApptTime',
            path: '/patient-info'
        },
        {
            stateKey: States_1.apptTime,
            stepperLabelId: 'stepperApptTime',
            ariaLabelId: 'ariaPatientInfo',
            path: '/appt-time'
        },
        {
            stateKey: States_1.apptSummary,
            stepperLabelId: 'appointmentConfirmedTitle',
            ariaLabelId: null,
            path: '/appt-summary'
        }
    ]
};
//# sourceMappingURL=steps.js.map